import React, { useEffect } from "react";
import { Dimmer, Loader } from "semantic-ui-react";
import { type PackListingView } from "../../types/state";
import { RichTextEditor, useRichTextEditor } from "../../../../../components/TextEditor";
import { isOtherPricingType } from "../../utils/packUtils";
import { PricingSection } from "./PricingSection";
import { type AccountTypeEnum } from "../../../../../interfaces/Account";
import styles from "./PackListingsOverview.module.scss";

interface Props {
  pack: PackListingView;
  hasPurchasePackAddon: boolean;
  accountId: number;
  isLoading: boolean;
  onPackRequest: () => void;
  onPackTrialRequest: () => void;
  onPackRemove: () => void;
  accountTypeId: AccountTypeEnum;
  parentAccountTypeId: AccountTypeEnum | null;
}

export const PackListingsOverview: React.FC<Props> = ({
  pack,
  isLoading,
  hasPurchasePackAddon,
  onPackRequest,
  onPackTrialRequest,
  onPackRemove,
  accountTypeId,
  parentAccountTypeId,
}) => {
  const { longDescription } = pack;
  const [editor, editorValue, handlers, utils] = useRichTextEditor(longDescription);
  const showPricingSection = !isLoading && !isOtherPricingType(pack.packPricingTypeId);

  useEffect(() => {
    editor.children = utils.convertToDescendant(longDescription);
  }, [longDescription, editor, utils]);

  return (
    <div className={styles.scrollableContent}>
      <div className={styles.listingOverviewContent}>
        {showPricingSection ? (
          <div className={styles.packOverviewContainer}>
            <div className={styles.descriptionSection}>
              <div className={styles.packListingOverviewInfo}>
                <div className={styles.overviewInfoText}>
                  <RichTextEditor
                    editor={editor}
                    value={editorValue}
                    isReadOnly
                    onChange={handlers.onChange}
                    showToolbar={false}
                  />
                </div>
              </div>
            </div>

            <div className={styles.pricingSection}>
              <div className={styles.pricingContent}>
                <PricingSection
                  pack={pack}
                  hasPurchasePackAddon={hasPurchasePackAddon}
                  onPackRequest={onPackRequest}
                  onPackTrialRequest={onPackTrialRequest}
                  onPackRemove={onPackRemove}
                  accountTypeId={accountTypeId}
                  parentAccountTypeId={parentAccountTypeId}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.packListingOverviewInfo}>
            <div className={styles.overviewInfoText}>
              <RichTextEditor
                editor={editor}
                value={editorValue}
                isReadOnly
                onChange={handlers.onChange}
                showToolbar={false}
              />
            </div>
          </div>
        )}
      </div>

      <Dimmer active={isLoading} inverted>
        <Loader />
      </Dimmer>
    </div>
  );
};
